/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_StartInputs */



/**
* | output |
* | --- |
* | "Start Time" |
*
* @param {Merge_Event_Group_Order_By_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_start = /** @type {((inputs?: Merge_Event_Group_Order_By_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heure de debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Startzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ora di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время начала")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hora de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय शुरू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hora de início")
	return /** @type {LocalizedString} */ ("Start Time")
});